import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// eslint-disable-next-line
import {
  Route,
  Redirect,
} from "react-router-dom";
import { verifyGroupsForInternalMenuItem } from "../store/ducks/duckMenuItemGroup";

import LoadingComponent from "./LoadingComponent";
import { useAuth } from "../auth/AuthProvider";

const CustomRoute = ({ component: Component, ...rest }) => {
  const { isInitialized, isAuthenticated, loginRedirect } = useAuth();
  const dispatch = useDispatch();
  const { isLoading, hasErrored } = useSelector((state) => state.menuItemGroup);
  const { path } = rest;

  useEffect(() => {
    if (isInitialized && !isAuthenticated) {
      loginRedirect({
        redirectPath: `${window.location.pathname}${window.location.search}${window.location.hash}`,
      });
    }
  }, [isAuthenticated, isInitialized, loginRedirect]);

  useEffect(() => {
    dispatch(verifyGroupsForInternalMenuItem(path));
  }, [dispatch, path]);

  if (!isInitialized || !isAuthenticated) {
    return <LoadingComponent loading />;
  }

  if (isLoading) {
    return <LoadingComponent loading={isLoading} />;
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        !hasErrored ? (
          <Component {...props} />
        ) : (
          <>
            <Redirect
              to={{
                pathname: "/Unauthorized",
                state: path,
              }}
            />
          </>
        )
      }
    />
  );
};

export default CustomRoute;
